import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const getReponsiveBreakPoints = ({ superLarge = 5, desktop = 3, tablet = 2, mobile = 1 } = {}) => {
  return {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      slidesToSlide: superLarge,
      items: superLarge,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      slidesToSlide: desktop,
      items: desktop,
    },
    tablet: {
      breakpoint: { max: 1023, min: 768 },
      slidesToSlide: tablet,
      items: tablet,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      slidesToSlide: mobile,
      items: mobile,
      partialVisibilityGutter: 15,
    },
  };
};

const MultiCarousel = ({
  children,
  containerClass = "container-with-dots w-100",
  infinite = true,
  resolutionCountsMapping,
  showDots = false,
  slidesToSlide = 1,
  partialVisible = false,
}) => {
  return (
    <Carousel
      additionalTransfrom={0}
      arrows
      autoPlaySpeed={3000}
      centerMode={false}
      className=""
      containerClass={containerClass}
      dotListClass=""
      draggable
      focusOnSelect={false}
      infinite={infinite}
      itemClass=""
      keyBoardControl
      minimumTouchDrag={80}
      pauseOnHover
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={getReponsiveBreakPoints(resolutionCountsMapping)}
      rewind={false}
      rewindWithAnimation={false}
      rtl={false}
      shouldResetAutoplay
      showDots={showDots}
      sliderClass=""
      slidesToSlide={slidesToSlide}
      swipeable
      partialVisible={partialVisible}
    >
      {children}
    </Carousel>
  );
};

export default MultiCarousel;
